import styleInject from '../node_modules/style-inject/dist/style-inject.es.js';

var css_248z = "";
var colors = {"tangerine":"#ff8400","darkred":"#ab192d","green":"#42ac82","red":"#ed002f"};
styleInject(css_248z);

export { colors as default };
